import React from 'react';
import styled from 'styled-components';
import theme from '../utils/theme';
import MainBanner from './common/MainBanner';
import CsImg from '../assets/LoanProductInfo/cs.png';

export default function LoanProductInfo() {
	const checkSvg = (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill={theme.mainColor} />
		</svg>
	);

	return (
		<MainBanner>
			<BannerDiv>
				<SectionTitle>
					차량담보대출,<br />
					나에게 맞는 조건 찾기!
					<TitleUnderline />
				</SectionTitle>
				<Cs src={CsImg} alt="cs" />
				<InfoGrid>
					<InfoCard>
						<CardHeader>
							<CheckIcon>{checkSvg}</CheckIcon>
							<CardTitle>자격조건</CardTitle>
						</CardHeader>
						<CardContent>
							<InfoItem>만 19세 이상, 차량을 소유한 고객<br />
								NICE 개인신용평점 530점 이상<br />
								(법인 명의 차량, 리스차 제외)</InfoItem>
						</CardContent>
					</InfoCard>
					<InfoCard>
						<CardHeader>
							<CheckIcon>{checkSvg}</CheckIcon>
							<CardTitle>대출한도</CardTitle>
						</CardHeader>
						<CardContent>
							<InfoItem>100만원 ~ 1억원</InfoItem>
						</CardContent>
					</InfoCard>
					<InfoCard>
						<CardHeader>
							<CheckIcon>{checkSvg}</CheckIcon>
							<CardTitle>대출기간</CardTitle>
						</CardHeader>
						<CardContent>
							<InfoItem>최단 12개월 ~ 최장 120개월</InfoItem>
						</CardContent>
					</InfoCard>
					<InfoCard>
						<CardHeader>
							<CheckIcon>{checkSvg}</CheckIcon>
							<CardTitle>대출금리</CardTitle>
						</CardHeader>
						<CardContent>
							<InfoItem>고정금리 : 대출 실행 시 결정한 금리가 약정기간 동안 동일하게 적용되는 금리<br />
								대출금리 : 최저 연 9.53% ~ 연 19.90% (개인신용평점에 따라 차등적용)</InfoItem>
						</CardContent>
					</InfoCard>
				</InfoGrid>
			</BannerDiv>
		</MainBanner>
	);
}

const BannerDiv = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 24px;
`;

const SectionTitle = styled.h2`
	color: ${theme.navyColor};
	font-size: 28px;
	font-weight: 700;
	margin: 40px 0;
	position: relative;
	text-align: center;
`;

const TitleUnderline = styled.div`
	width: 60px;
	height: 3px;
	background: ${theme.mainColor};
	margin: 16px auto 0;
	border-radius: 2px;
`;

const InfoGrid = styled.div`
	display: grid;
	max-width: 800px;
	margin: 0 auto;
	grid-template-columns: 1fr;
	gap: 16px;
`;

const InfoCard = styled.div`
	background: white;
	border-radius: 12px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	border: 1px solid ${theme.gray20Color};
`;

const CardHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
`;

const CheckIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

const CardTitle = styled.h3`
	color: ${theme.navyColor};
	font-size: 18px;
	font-weight: 600;
	margin: 0;
`;

const CardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const InfoItem = styled.p`
	color: ${theme.gray70Color};
	font-size: 14px;
	line-height: 1.5;
	margin: 0;
	font-weight: 400;
`;

const Cs = styled.img`
  width: 90%;
  height: auto;
  display: flex;
  align-self: center;
  object-fit: contain;
`;